import LegacyProjectCard from "./LegacyProjectCard";
import type {ProjectHit} from "./ProjectHit";
import UnifiedProjectCard from "./UnifiedProjectCard";

export type {ProjectHit} from "./ProjectHit";

/**
 * A search-result project card. The parent resolves the card variant once for
 * the full result list.
 */
export default function ProjectCard({
    project,
    unified,
    uniformHeight = false,
}: {
    project: ProjectHit;
    unified: boolean;
    uniformHeight?: boolean;
}) {
    return unified ? (
        <UnifiedProjectCard project={project} uniformHeight={uniformHeight} />
    ) : (
        <LegacyProjectCard project={project} />
    );
}
